export type Company = {
  id: string
  name: string
  initials: string
}

export type CompanyRecord = Record<string, Omit<Company, 'id'>>

import type { InjectionKey } from 'vue'

export const companyDictionaryKey = Symbol() as InjectionKey<CompanyRecord>
